import { LANGUAGE, Language } from "@/constants";

import DataDisplay, { DataDisplayComponent } from "./DataDisplay";

const LanguageDisplay: DataDisplayComponent<Language> = (props) => {
  const LANGUAGE_MAP = {
    [LANGUAGE.ENGLISH]: L.LANG_EN,
    [LANGUAGE.SWEDISH]: L.LANG_SV,
    [LANGUAGE.NORWEGIAN]: L.LANG_NO,
    [LANGUAGE.GERMAN]: L.LANG_DE,
    [LANGUAGE.DANISH]: L.LANG_DA,
    [LANGUAGE.FINNISH]: L.LANG_FI,
    [LANGUAGE.SPANISH]: L.LANG_ES,
    [LANGUAGE.FRENCH]: L.LANG_FR,
    [LANGUAGE.ITALIAN]: L.LANG_IT,
    [LANGUAGE.DUTCH]: L.LANG_NL,
    [LANGUAGE.PORTUGUESE]: L.LANG_PT,
  };

  return <DataDisplay dictionary={LANGUAGE_MAP} {...props} />;
};

export default LanguageDisplay;
